// Indicador de en que paso del wizard esta el usuario.
const WizardSteps = ({ paso }) => (
    <ol className="wizard-steps">
        <li className={`wizard-steps__item${paso >= 1 ? " wizard-steps__item--activo" : ""}`}>1. Tipo de búsqueda</li>
        <li className={`wizard-steps__item${paso >= 3 ? " wizard-steps__item--activo" : ""}`}>2. Fecha</li>
        <li className={`wizard-steps__item${paso >= 4 ? " wizard-steps__item--activo" : ""}`}>3. Turno</li>
    </ol>
);

export default WizardSteps;
